var _defs, _path, _g, _defs2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTumblrBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M0 0h30v30H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.308 20.955c-.363.177-1.06.332-1.58.346-1.566.043-1.87-1.123-1.884-1.97v-6.218h3.931V10.09H15.86V5.002h-2.867c-.048 0-.13.042-.14.15-.168 1.556-.883 4.29-3.852 5.381v2.58h1.981v6.527c0 2.234 1.615 5.408 5.88 5.334 1.437-.025 3.035-.64 3.389-1.17l-.942-2.849z",
    fill: "#F8F8F8"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 5)",
    d: "M0 0h11.25v20H0z"
  })))));
}

var MemoSvgTumblrBlog = /*#__PURE__*/React.memo(SvgTumblrBlog);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiBmaWxsPSIjMTcxNzE3Ii8+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMCkiPgo8cGF0aCBkPSJNMTkuMzA4NCAyMC45NTUyQzE4Ljk0NDUgMjEuMTMyNCAxOC4yNDgyIDIxLjI4NjUgMTcuNzI4NCAyMS4zMDA1QzE2LjE2MjIgMjEuMzQzNSAxNS44NTgxIDIwLjE3NzYgMTUuODQ0NCAxOS4zMzFWMTMuMTEzMkgxOS43NzUyVjEwLjA4OThIMTUuODU5MlY1LjAwMTk1SDEyLjk5MTVDMTIuOTQ0NSA1LjAwMTk1IDEyLjg2MjEgNS4wNDM5NyAxMi44NTEzIDUuMTUxMDZDMTIuNjgzNiA2LjcwODI4IDExLjk2ODYgOS40NDEzNyA5IDEwLjUzMzNWMTMuMTEzMkgxMC45ODFWMTkuNjQwMkMxMC45ODEgMjEuODc0IDEyLjU5NjMgMjUuMDQ4NCAxNi44NjA1IDI0Ljk3NDNDMTguMjk4MiAyNC45NDkzIDE5Ljg5NTggMjQuMzMzOCAyMC4yNDk4IDIzLjgwNDVMMTkuMzA4NCAyMC45NTUyWiIgZmlsbD0iI0Y4RjhGOCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjExLjI1IiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOSA1KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { MemoSvgTumblrBlog as ReactComponent };